import { render, staticRenderFns } from "./Carro.vue?vue&type=template&id=c33de576&"
import script from "./Carro.vue?vue&type=script&lang=js&"
export * from "./Carro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports